import { BaseWebComponentController, IListenerConfig } from '../../../../framework/BaseWebComponentController';
import { SensorEvent } from '../../types/sensor-type';
import { BaseSensorWebComponent } from '../BaseSensorWebComponent';
import { BaseSensorWebView } from '../view/BaseSensorWebView';
import { FormGroupValue } from '../../../../ui/gzForm/formGroup/types/form-group-value';

export abstract class BaseSensorWebController extends BaseWebComponentController {
  public view: BaseSensorWebView;
  public component: BaseSensorWebComponent;

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$sensorSelectWrapper,
        event: 'change',
        callback: this.toggleEnable,
      },
      {
        element: this.view.dom.$wrapper,
        event: SensorEvent.init,
        callback: this.postInit,
      },
    ];
  }

  public inputChanged(ev): void {
    this.dispatchSensorEvent(SensorEvent.change, {
      type: this.component.getSensorType(),
      sourceEvent: ev.detail.sourceEvent,
    });
  }

  protected dispatchSensorEvent(eventName: SensorEvent, details: Object): void {
    this.component.dispatchEvent(
      new CustomEvent(eventName, {
        detail: details,
        bubbles: true,
        composed: true,
      })
    );
  }

  public resetData(): void {
    this.component.setSensorId(null);
    this.view.resetData();
  }

  public isSensorEnabled(): boolean {
    return this.view.dom.$sensorSelectWrapper ? this.view.dom.$sensorSelectWrapper.Input.checked : false;
  }

  public toggleEnable(): void {
    const isCurrentSensorEnabled = this.isSensorEnabled();
    this.dispatchSensorEvent(SensorEvent.enableSensor, {
      sensorType: this.component.getSensorType(),
      enabled: isCurrentSensorEnabled,
    });

    this.view.setEnableOnDataFields(isCurrentSensorEnabled);
  }

  public setDataInForm(viewData: FormGroupValue): void {
    this.view.formGroup.value = viewData;
  }

  public setEnabledAllFields(isEnabled: boolean): void {
    this.view.setEnabledAllFields(isEnabled);
  }

  async getDataForView(): Promise<any> {
    if (!this.component.getSensorId()) {
      return {};
    }

    const data = await this.dependencies.api.clients.SensorsIntegrations.getSensorById({
      sensorId: this.component.getSensorId(),
    });
    return data;
  }

  public isFormEmpty(): boolean {
    const formGroup = this.view.formGroup;
    return Object.values(formGroup.value).every(field => field === '');
  }

  public postInit(ev): void {}
}
